import { useMutation } from '@tanstack/react-query';
import { Auth } from '#api';

export function useSignupMutation() {
  return useMutation({ mutationFn: Auth.signup });
}
